import { WidgetPanel } from "@/components/dashboard-grid/WidgetPanel";
import type { OverviewFunnel } from "@/hooks/useDashboardOverview";

const STAGES: { key: "teasers" | "ndas" | "cims" | "iois" | "lois"; label: string }[] = [
  { key: "teasers", label: "Teaser" }, { key: "ndas", label: "NDA" }, { key: "cims", label: "CIM" },
  { key: "iois", label: "IOI" }, { key: "lois", label: "LOI" },
];
const pct = (n: number) => `${(n * 100).toFixed(n > 0 && n < 0.1 ? 1 : 0)}%`;

/** The old dashboard's per-deal buyer funnel, now an opt-in library widget. */
export function BuyerFunnelWidget({ funnel }: { funnel: OverviewFunnel | undefined }) {
  if (!funnel) {
    return <WidgetPanel title="Buyer funnel"><p className="px-3 py-4 text-sm text-muted-foreground">This deal is no longer active. Remove the widget in Customize.</p></WidgetPanel>;
  }
  const max = Math.max(funnel.teasers, 1);
  return (
    <WidgetPanel title={funnel.projectName ?? funnel.client.name} meta={`buyer funnel · ${funnel.client.name}`}>
      <div className="grid grid-cols-[2.5rem_1fr_3rem] items-center gap-x-2 gap-y-1.5 px-3 py-2 text-xs">
        {STAGES.map((s, i) => (
          <div key={s.key} className="contents">
            <span className="text-muted-foreground">{s.label}</span>
            <span className="h-3 bg-muted rounded-sm overflow-hidden">
              <span className={i >= 3 ? "block h-full bg-amber-500" : "block h-full bg-sidebar dark:bg-primary"} style={{ width: `${funnel[s.key] > 0 ? Math.max((funnel[s.key] / max) * 100, 2) : 0}%` }} />
            </span>
            <span className="text-right font-medium tabular-nums">{funnel[s.key].toLocaleString()}</span>
          </div>
        ))}
        <p className="col-span-3 text-[11px] text-muted-foreground pt-1">
          {pct(funnel.conversions.teaserToNda)} teaser to NDA · {pct(funnel.conversions.cimToIoi)} CIM to IOI
        </p>
      </div>
    </WidgetPanel>
  );
}
